export default {
  apply_fascia: 'Booth Sign Applicitions',
  apply: 'apply',
  applied_fascia: 'Applied Booth Sign Info',
  modify_fascia_deadline: 'Deadline for modify Booth Sign:',
  fascia_config: 'Shows the Booth Sign note here',
  boothNo: 'boothNo',
  company_name: 'companyName',
  en_company_name: 'English CompanyName',
  contactPerson: 'contactPerson',
  phone: 'phone',
  email: 'email',
  address: 'address',
  apply_date: 'date of applying',
  action: 'Action',
  modify_fascia: 'modify',
  cn_company_name: 'Chinese CompanyName',
  form_title: 'Fill in the Booth Sign information',
  form_tips: 'If the booth number is not found by the system, please confirm with the home venue service personnel.',
  form_save: 'submit',
  form_cancel: 'cancel',
  form_boothNo_check: 'please enter the boothNo',
  form_cn_company_name_check: 'please enter the Chinese CompanyName',
  form_en_company_name_placeholder: 'please enter the English CompanyName',
  form_address_placeholder: 'please enter the address',
  form_contactPerson_check: 'please enter the contactPerson',
  form_phone_placeholder: 'please enter the phone',
  form_phone_check: 'Please enter the correct phone number',
  form_email_placeholder: 'please enter the email',
  form_email_check: 'please enter the correct email',
  loding: 'loading...',
  action_success: 'Success!',
  request_error: 'Request Data Error!',
  save_error_title: 'Operation Failure',
  save_error: 'You must fill out either the Chinese or the English name of your company',
  '仅特装可申请楣板': 'Only special booths can apply for fascia board',
  '仅标摊展位可申请楣板': 'Only the standard booth can apply for fascia board',
  '展位号不存在': 'Booth number does not exist',
}



// WEBPACK FOOTER //
// ./src/i18n/en-us/fascia.js